module.exports = "<!-- Intentionally empty -->"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/authentication/sso-handler/sso-handler.component.html
// module id = ../../../../../src/app/authentication/sso-handler/sso-handler.component.html
// module chunks = main